<p-confirmDialog />
<p-toast />
<div *ngIf="this.loading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="container px-4 py-5">
  <div class="px-3 py-10">
    <p-card class="p-card">
      <ng-template pTemplate="header">
        <h2 class="text-2xl font-bold">Customer Details</h2>
      </ng-template>
      <div class="text-right">
        <p-button
        (click)="menu.toggle($event)"
        icon="pi pi-ellipsis-v" />            
      </div>
      <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
  <div class="col-span-12 mb-4 md:col-span-6">
        <label for="first_name" class="block mb-1 font-medium">
          First Name
        </label>
        <input
          p-inputText
          id="first_name"
          readonly="true"
          [(ngModel)]="customer()!.first_name"
          type="text" />
      </div>
      <div class="col-span-12 mb-4 md:col-span-6">
        <label for="last_name" class="block mb-1 font-medium">Last Name</label>
        <input
          p-inputText
          id="last_name"
          readonly="true"
          [(ngModel)]="customer()!.last_name"
          type="text" />
      </div>
      <div class="col-span-12 mb-4 md:col-span-6">
        <label for="email" class="block mb-1 font-medium">Email</label>
        <input
          p-inputText
          id="email"
          readonly="true"
          [(ngModel)]="customer()!.email"
          type="text" />
      </div>
      <div class="col-span-12 mb-4 md:col-span-6">
        <label for="mobile_phone" class="block mb-1 font-medium">
          Mobile Phone
        </label>
        <input
          p-inputText
          id="mobile_phone"
          readonly="true"
          [(ngModel)]="customer()!.mobile_phone"
          type="text" />
      </div>
      <div class="col-span-12 mb-4 md:col-span-6">
        <label for="status" class="block mb-1 font-medium">Status</label>
        <span [ngClass]="customer()!.status === 'ACTIVE' ? 'green' : 'red'">
          <input
            p-inputText
            id="status"
            readonly="true"
            [(ngModel)]="customer()!.status"
            type="text" />
        </span>
      </div>
      <div class="mb-4 form-group">
        <label
          for="autopay"
          class="block text-sm font-medium text-gray-700">
          Autopay:
        </label>
        <p-toggleswitch 
          id="autopay"
          readonly="true"
          [(ngModel)]="customer()!.autopay_status"
          />
      </div>
      <div class="col-span-12 mb-4 md:col-span-6">
        <label for="references" class="block mb-1 font-medium">
          References
        </label>
        <div>
          <pre [innerHTML]="customer()!.reference_keys | jsonToText"></pre>
        </div>
      </div>
    </p-card>
    <app-latest-invoice-payment [customer_overview]="customer">
    </app-latest-invoice-payment>
    <app-payment-methods [customer]="customer"></app-payment-methods>
    <app-subscription-card
      [subscriptions]="this.subscriptions!"></app-subscription-card>
    <app-asset-card [assets]="this.assets!"></app-asset-card>
    <app-invoices-card [invoices]="this.invoices!"></app-invoices-card>
    <app-payments-card [payments]="this.payments!"></app-payments-card>
  </div>
</div>
